import React from 'react';
import { MapLegendModalProps } from '../MapLegend/MapLegendModal';
import { useAppSelector } from 'hooks/redux';
import { Box, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

export const MetadataModal: React.FC<MapLegendModalProps> = ({
  open,
  handleClose,
}) => {
  const { currenMetaFileUrl } = useAppSelector((state) => state.layers);

  return open ? (
    <Box
      sx={{
        border: '1px solid',
        borderColor: 'divider',
        zIndex: 1000,
        borderRadius: '2px',
      }}
    >
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'end',
          alignItems: 'center',
        }}
      >
        <IconButton onClick={handleClose} sx={{ p: 0 }}>
          <CloseIcon />
        </IconButton>
      </Box>
      <Box sx={{ overflow: 'auto' }}>
        <img
          id="legend-ref"
          src={currenMetaFileUrl}
          alt="legeng"
          style={{ maxWidth: '60vw', maxHeight: '50vh' }}
        />
      </Box>
    </Box>
  ) : null;
};
